export default __webpack_public_path__ + "static/media/home_banner.ddfaebcc.jpg";